import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/images/10134.png'


const _hoisted_1 = { class: "relative shift-register-member" }
const _hoisted_2 = { class: "box-member flex justify-between p-5 items-center" }
const _hoisted_3 = { class: "box-member-gr" }
const _hoisted_4 = { class: "box-member__check pt-3 pb-3" }
const _hoisted_5 = { class: "box-member__time flex items-baseline" }
const _hoisted_6 = { class: "box-member__desc ml-2" }
const _hoisted_7 = { class: "box-member__date" }
const _hoisted_8 = { class: "box-shift-register__button mb-4" }
const _hoisted_9 = { class: "overflow-auto" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "register-avatar" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_12 = { class: "register-information mr-4" }
const _hoisted_13 = { class: "whitespace-no-wrap" }
const _hoisted_14 = { class: "whitespace-no-wrap" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "register-icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.5 23C6.70101 23 2 18.299 2 12.5C2 6.70101 6.70101 2 12.5 2C18.299 2 23 6.70101 23 12.5C23 18.299 18.299 23 12.5 23ZM12.5 22C17.7467 22 22 17.7467 22 12.5C22 7.25329 17.7467 3 12.5 3C7.25329 3 3 7.25329 3 12.5C3 17.7467 7.25329 22 12.5 22ZM8 12.5C8 12.7761 8.22386 13 8.5 13H16.5C16.7761 13 17 12.7761 17 12.5C17 12.2239 16.7761 12 16.5 12H8.5C8.22386 12 8 12.2239 8 12.5Z",
      fill: "#666666"
    })
  ])
], -1)
const _hoisted_16 = { class: "relative h-full -m-1" }
const _hoisted_17 = { class: "relative h-full -m-1" }
const _hoisted_18 = { class: "flex mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_GradationButton = _resolveComponent("GradationButton")
  const _component_Select = _resolveComponent("Select")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Checkbox, {
            class: "mr-5",
            "option-checkbox": { label: _ctx.t('registerMember.target') }
          }, null, 8, ["option-checkbox"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", null, _toDisplayString(_ctx.t('registerMember.targetPeriod')) + " :", 1),
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.t('registerMember.textExample')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_DatePicker, {
          width: "120",
          "is-icon-chevron-left": "",
          "is-icon-chevron-right": "",
          type: "date",
          format: "YYYY/MM/DD"
        })
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_GradationButton, { class: "storybook-button--large" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('registerMember.notifyMembersCreated')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_Table, {
        headers: _ctx.shiftRegisterDataHeader,
        data: _ctx.shiftRegisterData
      }, {
        shift_pattern_name: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _createVNode("span", _hoisted_13, _toDisplayString(item.shift_pattern_name), 1),
              _createVNode("span", _hoisted_14, _toDisplayString(item.shift_pattern_job), 1)
            ]),
            _hoisted_15
          ])
        ]),
        shift_pattern: _withCtx(({ item }) => [
          _createVNode(_component_Select, {
            modelValue: item.shift_pattern,
            "onUpdate:modelValue": ($event: any) => (item.shift_pattern = $event),
            class: "text-center",
            "options-select": _ctx.shiftPatternOptions,
            "item-value": "value",
            "item-text": "text",
            "select-option-color": _ctx.onChoseColorRanDom
          }, null, 8, ["modelValue", "onUpdate:modelValue", "options-select", "select-option-color"])
        ]),
        target_time: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.displayTargetTime(item)), 1)
        ]),
        "9AM": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_16, [
            _createVNode("div", {
              class: "time-line",
              style: _ctx.styleTimeLine(item)
            }, null, 4)
          ])
        ]),
        "10AM": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_17, [
            _createVNode("div", {
              class: "time-line",
              style: _ctx.styleTimeLine(item)
            }, null, 4)
          ])
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode("span", {
        class: "flex action--add whitespace-no-wrap",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addTimezoneDetail && _ctx.addTimezoneDetail(...args)))
      }, [
        _createVNode("img", {
          src: _ctx.Plus,
          alt: "",
          srcset: ""
        }, null, 8, ["src"]),
        _createTextVNode(_toDisplayString(_ctx.t('registerMember.addMember')), 1)
      ])
    ])
  ]))
}